import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'helpers/GlobalHelper';

const Failure = ({
  theme,
  sharedTheme,
  children,
  contentChildren,
  rendered,
  contentChildrenParams,
  backgroundInline,
}) => {
  if (!rendered) return null;
  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : null;

  return (
    <div className={classNames(sharedTheme.container, theme.container)}>
      <div
        className={classNames(sharedTheme.innerContainer, theme.innerContainer)}
        style={innerContainerStyle}
      >
        <div className={theme.content}>
          {contentChildren(contentChildrenParams)}
          {children}
        </div>
      </div>
    </div>
  );
};

Failure.propTypes = {
  theme: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
  contentChildren: PropTypes.func,
  contentChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundInline: PropTypes.shape({}),
};

Failure.defaultProps = {
  theme: null,
  sharedTheme: null,
  contentChildren: noop,
  contentChildrenParams: null,
  rendered: PropTypes.bool,
  children: null,
  backgroundInline: null,
};

export default Failure;
